import { render, staticRenderFns } from "./TimeBasedRouter.vue?vue&type=template&id=7b6aeab5"
import script from "./TimeBasedRouter.vue?vue&type=script&lang=js"
export * from "./TimeBasedRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports